import React, { useContext, useRef, useState } from "react";
import { Grid } from "@mui/material";
import { useSnackbar } from "notistack";
import { AuthContext } from "context";
import {
  useHosterCreate,
  useHosterRead,
  useHosterRoutes,
  useHosterUpdate,
} from "hooks";
import { CustomButton } from "core";
import { Loading } from "core";
import { BoxHeadlineContainer } from "layout/Container/BoxHeadlineContainer";
import { HosterForm, HosterFormHandles } from "../HosterForm";
import useStyles from "./styles";

type HosterFormPageProps = {
  formIntent: "create" | "edit";
};

export const HosterFormPage: React.FC<HosterFormPageProps> = ({
  formIntent,
}) => {
  const { classes } = useStyles();
  const authContext = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();

  const { hoster, isLoading } = useHosterRead();
  const createHosterMutation = useHosterCreate();
  const updateHosterMutation = useHosterUpdate();
  const { navigateToHosterPage, navigateToHosterListPage } = useHosterRoutes();

  const hosterFormRef = useRef<HosterFormHandles>(null);

  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  const submitHoster = async () => {
    const hosterFormInput = hosterFormRef.current?.validateHosterForm();
    if (!hosterFormInput) {
      console.error("HosterForm is invalid...");
      return;
    }

    if (!authContext.user) {
      return enqueueSnackbar(
        `Beim ${
          formIntent === "edit" ? "Bearbeiten" : "Anlegen"
        } eines Hosters ist ein Fehler aufgetreten.`,
      );
    }

    setSubmitLoading(true);

    console.log("hosterInput: ", hosterFormInput);

    const mutateHosterRequest = hoster
      ? await updateHosterMutation.mutateAsync({
          ...hosterFormInput,
          id: hoster.id,
        })
      : await createHosterMutation.mutateAsync(hosterFormInput);

    if (!mutateHosterRequest) {
      setSubmitLoading(false);
      return enqueueSnackbar(
        `Beim ${
          formIntent === "edit" ? "Bearbeiten" : "Anlegen"
        } eines Hosters ist ein Fehler aufgetreten.`,
      );
    }

    console.log("mutateHosterRequest: ", mutateHosterRequest);

    setSubmitLoading(false);
    navigateToHosterPage(mutateHosterRequest);
  };

  if (isLoading) {
    return (
      <BoxHeadlineContainer
        boxTitle={
          "Hoster " + (formIntent === "edit" ? "bearbeiten" : "anlegen")
        }
      >
        <Loading
          description="Bitte warten. Hoster wird geladen... "
          size="25px"
        />
      </BoxHeadlineContainer>
    );
  }

  return (
    <BoxHeadlineContainer
      boxTitle={"Hoster " + (formIntent === "edit" ? "bearbeiten" : "anlegen")}
    >
      <HosterForm hoster={hoster} formIntent={formIntent} ref={hosterFormRef} />

      <Grid container direction="row" className={classes.buttons}>
        <Grid item className={classes.gridItem}>
          <CustomButton
            text={"Hoster " + (formIntent === "edit" ? "speichern" : "anlegen")}
            onClick={() => submitHoster()}
            loading={submitLoading}
            accessKey="s"
          />
        </Grid>
        <Grid item className={classes.gridItem}>
          <CustomButton
            color="red"
            text="Abbrechen"
            accessKey="a"
            onClick={() => navigateToHosterListPage()}
            disabled={submitLoading}
          />
        </Grid>
      </Grid>
    </BoxHeadlineContainer>
  );
};
